import { ref } from 'vue';

export const verticals = [
    { name: 'Casino', code: 'casino' },
    { name: 'Sportsbook', code: 'sportsbook' }
];

// Helper function to get vertical name by code
export const getVerticalName = (code) => {
    const vertical = verticals.find(vertical => vertical.code === code);
    return vertical ? vertical.name : 'Unknown';
};

// Helper function to get all verticals
export const getVerticals = () => {
    return verticals;
};

export default verticals; 